import { useMemo } from 'react'
import cn from 'classnames'
import BlockContent from '@sanity/block-content-to-react'
import { createUseStyles } from '../../helpers/createStyles'
import { createSerializers } from '../../lib/serializers'
import { span, theme } from '../../styles/theme'
import Section from '../Section'

const JournalText = ({ data: { content } }) => {
  const styles = useStyles()
  const serializers = useMemo(() => {
    return createSerializers({ styledLinks: true, buttonCtas: true })
  }, [])

  return (
    <Section grid noBottomMargin>
      <BlockContent
        renderContainerOnSingleChild
        blocks={content}
        serializers={serializers}
        className={cn(styles.content)}
      />
    </Section>
  )
}

const useStyles = createUseStyles({
  content: {
    gridColumn: '1 / span 8',
    [theme.breakpoints.up('md')]: {
      gridColumnStart: 5,
      gridColumnEnd: 'span 4',
      '.dialog-grid &': {
        gridColumnStart: 4
      }
    },
    '& > .is-indent': {
      [theme.breakpoints.up('md')]: {
        marginLeft: span(-2, 'md')
      }
    },
    '& li': {
      marginBottom: '0.5rem'
    },
    '& > *': {
      marginBottom: `${theme.spacingPx(5)}!important`,
      [theme.breakpoints.up('md')]: {
        marginBottom: `${theme.spacingPx(8)}!important`
      }
    },
    '& > h4, & > .is-h4': {
      fontSize: '24px',
      [theme.breakpoints.up('md')]: {
        fontSize: '32px'
      }
    }
  }
})

export default JournalText
